







































































































































































































































































































































































































































































































































































































import { Vue, Component, Watch }    from 'vue-property-decorator'
import { mapGetters, mapState }     from 'vuex'
import { FontAwesomeIcon }          from '@fortawesome/vue-fontawesome'
import { Ability }                  from '@/types/Ability'
import ExaGenericTable from '@exatech-group/generic-table/src/GenericTable.vue'
import { base64ToArrayBuffer, diffTwoDatesInMinutes, formatDate, formatDateYYYYMMDD, formatDayHourZDateFromString, formatEndOfDayHourZDateFromString, getFileNameFromHeader, numberWithSpaces } from '@/utils/helpers'
import  ErrorDisplay from '@/components/ErrorDisplay.vue'
import { getStatutReception, StatutReception, get_color_statut } from '@/types/Centre'
import _ from 'lodash'
import { FournitureAdministrativeInterface } from '@/types/FournitureAdministrative'
import moment from 'moment'

@Component({
    computed: {
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA', 'user_session_id']),
        ...mapState('auth', ['user', 'authUser', 'user_session_id']),
        ...mapState('repartitioncandidats', ['liste_centres', 'lastPage', 'totalRows', 'loading_repartition']),
        ...mapGetters('repartitioncandidats', ['get_centres_satures']),
        ...mapGetters('concour', ['banques']),
        ...mapState('ville', ['zones']),

        ...mapState('session', ['sessionSelect'])
    },
    components: {
        ExaGenericTable,
        'font-awesome-icon': FontAwesomeIcon,
        ErrorDisplay
    }
})

export default class SuiviFournitures extends Vue
{
    formatDate = formatDate
    Ability = Ability
    getStatutReception = getStatutReception
    StatutReception = StatutReception
    get_color_statut = get_color_statut

    // Ensemble des colonnes du tableau
    genericfields: any = []

    sortBy          = '';
    sortDesc        = false;
    sortDirection   = 'asc';
    filter          = '';
    filterOn        = [];
    stickyHeader    = true;
    params: any = {
        page: 1,
        sort: 'name',
        direction: 'asc'
    }

    filtres:    any         = []
    dataForTab: Array<any>  = [
    ]

    exportingIsWorking = false

    infos: any = null

    showPopupPublicationInventaire = false
    showPopupRelanceCentre = false
    showPopupMargeCommande = false
    showPopupStatutCentre = false
    showPopupOptionsZones = false
    selectedDate = {
        userSelectDateType: 'closeInput',
        dateBetween: {
            date_start: '',
            date_end: ''
        },
        onlyEndDate: {
            date_end: ''
        }
    }

    betweenError = ''
    onlyEndDateError = ''

    params_marge: any = {
        sujet_commande_marge_securite: 0,
        sujet_commande_supplementaires_min: 0,
        sujet_commande_supplementaires_max: 0
    }

    showGestionNombreSujets = false
    filiere_gestion_nombre_sujets = null
    marge_securite = 0
    sujet_supplementaire = 0
    listeSujets: Array<any> = []
    listeSujetsOriginal: Array<any> = []
    totalPagesImprimees = 0
    numberWithSpaces = numberWithSpaces

    options_filieres: Array<any> = []
    type_statut = ''
    statut_centre: any = null
    info_statut_centre = ''
    options_zones_export: any = []
    save_in_progress = false

    @Watch('sessionSelect')
    refreshEtatInventaire () {
        this.getStateInventaire()
    }

    @Watch('user_session_id')
    refreshInterface () {
        this.$store.state.repartitioncandidats.loading_repartition = true
        this.load()
    }

    @Watch('liste_centres')
    resetDataTable () {
        // Fields du tableau
        this.genericfields = [
            { key: 'name', label: 'Centre', sortable: false, class: '', type: 'text' },
            { key: 'filiere', label: 'Filière', sortable: false, class: '', type: 'text' },
            { key: 'ville.name', label: 'Ville', sortable: false, class: '', type: 'text' },
            { key: 'zone', label: 'Zone', sortable: false, class: '', type: 'text' }
        ]

        // Compteur de colonnes pour indiquer les centres ok - AR CENTRE VERT
        const compteur_sujets_ok = this.$store.state.repartitioncandidats.liste_centres.filter((c: any) => c.f_suj_statut === StatutReception.AR_CENTRE && c.sujets_pb_count === 0)
        const compteur_pap_ok = this.$store.state.repartitioncandidats.liste_centres.filter((c: any) => c.f_pap_statut === StatutReception.AR_CENTRE && c.fourniture_papetieres_pb_count === 0)
        const compteur_fa_ok = this.$store.state.repartitioncandidats.liste_centres.filter((c: any) => c.f_adm_statut === StatutReception.AR_CENTRE && c.fourniture_administratives_pb_count === 0)

        this.genericfields.push({ key: 'sujets', label: compteur_sujets_ok.length + ' / ' + this.$store.state.repartitioncandidats.liste_centres.length, sortable: false, class: 'text-center text-info', type: 'text', doubleHeaderLabel: 'Sujets', doubleHeaderColSpan: 1, doubleHeaderClass: 'text-center' })
        this.genericfields.push({ key: 'fournitures_papetieres', label: compteur_pap_ok.length + ' / ' + this.$store.state.repartitioncandidats.liste_centres.length, sortable: false, class: 'text-center text-info', type: 'text', doubleHeaderLabel: 'Fournitures papetières', doubleHeaderColSpan: 1, doubleHeaderClass: 'text-center' })
        this.genericfields.push({ key: 'fournitures_administratives', label: compteur_fa_ok.length + ' / ' + this.$store.state.repartitioncandidats.liste_centres.length, sortable: false, class: 'text-center text-info', type: 'text', doubleHeaderLabel: 'Fournitures administratives', doubleHeaderColSpan: 1, doubleHeaderClass: 'text-center' })
        if (this.genericfields.length !== 0) {
            const datas = _.orderBy(this.$store.state.repartitioncandidats.liste_centres, 'ville.name', 'asc')
            this.setDataForGenericTab(datas)
        }
    }

    @Watch('statut_centre')
    buildInfoStatut () {
        if (this.statut_centre === StatutReception.EN_PRODUCTION) {
            this.info_statut_centre = 'Les centres ayant les salles validées et dont le statut est actuellement <strong>"En préparation"</strong> se verront attribuer le statut <strong>"En production"</strong>.'
        } else if (this.statut_centre === StatutReception.EN_LIVRAISON) {
            this.info_statut_centre = 'Les centres ayant les salles validées et dont le statut est actuellement <strong>"En production"</strong> se verront attribuer le statut <strong>"En livraison"</strong>.'
        } else if (this.statut_centre === StatutReception.AR_TRANSPORTEUR) {
            this.info_statut_centre = 'Les centres ayant les salles validées et dont le statut est actuellement <strong>"En livraison"</strong> se verront attribuer le statut <strong>"AR Transporteur"</strong>.'
        }

        this.info_statut_centre += '<br/>Vous pourrez toujours modifier individuellement le statut de chaque centre.'
    }

    // Retourne l'état de publication de l'inventaire
    getStateInventaire () {
        let state_inventaire = { message: '', bg_color: 'barre_default', text_color: '' }
        if (this.$store.state.session.sessionSelect) {
            if (!this.$store.state.session.sessionSelect.inventaire_fournitures_start_at && !this.$store.state.session.sessionSelect.inventaire_fournitures_end_at) {
                state_inventaire = { message: 'L\'inventaire n\'est pas accessible aux centres.', bg_color: 'barre_default', text_color: 'barre_text_defaut' }
            } else if (!this.$store.state.session.sessionSelect.inventaire_fournitures_start_at && this.$store.state.session.sessionSelect.inventaire_fournitures_end_at) {
                state_inventaire = { message: 'L\'inventaire est accessible aux centres jusqu\'au ' + formatDate(this.$store.state.session.sessionSelect.inventaire_fournitures_end_at) + ' inclus.', bg_color: 'barre_soumis', text_color: 'barre_text_soumis' }
            } else if (this.$store.state.session.sessionSelect.inventaire_fournitures_start_at && this.$store.state.session.sessionSelect.inventaire_fournitures_end_at) {
                state_inventaire = { message: 'L\'inventaire est accessible aux centres du ' + formatDate(this.$store.state.session.sessionSelect.inventaire_fournitures_start_at) + ' au ' + formatDate(this.$store.state.session.sessionSelect.inventaire_fournitures_end_at) + ' inclus.', bg_color: 'barre_soumis', text_color: 'barre_text_soumis' }
            }
        }

        return state_inventaire
    }


    // Chargement des données du tableau
    setDataForGenericTab (poData: any, isLoadMore = false)
    {
        if (!isLoadMore)
        {
            this.dataForTab = []
        }

        if (poData)
        {
            for (const result of poData)
            {
                // Chaine des concours du centre
                let concours_string = ''
                if (result.concours.length !== 0) {
                    for (const c in result.concours) {
                        let separateur = ' '
                        if (Number(c) !== (result.concours.length - 1)) {
                            separateur = ', '
                        }
                        concours_string += result.concours[c].code + separateur
                    }
                }

                // Zone du centre
                let zone = ''
                if (result.ville && result.ville.zone_id) {
                    zone = result.ville.zone.name
                }

                // Accés suivi des sujets
                const btnSujets: any[] = []
                const statut_sujet: any = getStatutReception(result.f_suj_statut, result.sujets_pb_count)
                let class_bg_sujets = ''
                btnSujets.push({ name: statut_sujet.icone, typeIcon: 'fas', class:'text-start font_medium text-' + statut_sujet.color, title: '', value_comp: (result.f_suj_validated_at ? 'Validé' : statut_sujet.libelle), result: { id: result.id, tab: 'Sujet' } })
                btnSujets.push({ name:'arrow-circle-right', typeIcon: 'fal', class:'text-start text-' + statut_sujet.color, title: '', value_comp: null, result: { id: result.id, tab: 'Sujet' } })
                class_bg_sujets = statut_sujet.bg_color

                // Accés suivi des fournitures papetières
                const btnFP: any[] = []
                const statut_fp: any = getStatutReception(result.f_pap_statut, result.fourniture_papetieres_pb_count)
                let class_bg_fp = ''
                btnFP.push({ name: statut_fp.icone, typeIcon: 'fas', class:'text-start font_medium text-' + statut_fp.color, title: '', value_comp: (result.f_pap_validated_at ? 'Validé' : statut_fp.libelle), result: { id: result.id, tab: 'FourniturePapetiere' } })
                btnFP.push({ name:'arrow-circle-right', typeIcon: 'fal', class:'text-start text-' + statut_fp.color, title: '', value_comp: null, result: { id: result.id, tab: 'FourniturePapetiere' } })
                class_bg_fp = statut_fp.bg_color

                // Accés suivi des fournitures administratives
                const btnFA: any[] = []
                const statut_fa: any = getStatutReception(result.f_adm_statut, result.fourniture_administratives_pb_count)
                let class_bg_fa = ''
                btnFA.push({ name: statut_fa.icone, typeIcon: 'fas', class:'text-start font_medium text-' + statut_fa.color, title: '', value_comp: (result.f_adm_validated_at ? 'Validé' : statut_fa.libelle), result: { id: result.id, tab: 'FournitureAdministrative' } })
                btnFA.push({ name:'arrow-circle-right', typeIcon: 'fal', class:'text-start text-' + statut_fa.color, title: '', value_comp: null, result: { id: result.id, tab: 'FournitureAdministrative' } })
                class_bg_fa = statut_fa.bg_color

                const line = [
                    { label: '', item: result.name, type: 'text', typeAction: null, class: '' },
                    { label: '', item: concours_string, type: 'text', typeAction: null, class: '' },
                    { label: '', item: result.ville ? result.ville.name : '-', type: 'text', typeAction: null, class: 'font_medium ' + '' },
                    { label: '', item: zone, type: 'text', typeAction: null, class: '' },
                    { label: '', item: btnSujets, type: 'icons', typeAction: 'goSuivi', class: 'text-center min_width_suivi ' + class_bg_sujets },
                    { label: '', item: btnFP, type: 'icons', typeAction: 'goSuivi', class: 'text-center min_width_suivi ' + class_bg_fp },
                    { label: '', item: btnFA, type: 'icons', typeAction: 'goSuivi', class: 'text-center min_width_suivi ' + class_bg_fa }
                ]
                this.dataForTab.push(line)
            }
        }
    }

    /**
     * Récupération des events du tableau
     * params[0] => l'action
     * params[1] => l'id de l'item
     */
    handleTableEvent (paParams: any): void
    {
        if (paParams && paParams[0] && paParams[1])
        {
            switch (paParams[0])
            {
                case 'goSuivi':
                    this.$router.push('/suivi_sujets_fournitures/' + paParams[1][0].result.id + '?tab=' + paParams[1][0].result.tab)
                    break
                case 'sortHandler':
                    this.filtreSortHandler(paParams[1])
                    break
                case 'filterHandler':
                    this.filtreSortHandler(paParams[1])
                    break
                case 'onLoadPage':
                    this.loadHandler(paParams[1])
                    break

                default:
                    break
            }
        }
    }

    // Chargement des données du tableau
    filtreSortHandler (params: any) {
        if (JSON.stringify(this.params) !== JSON.stringify(params)) {
            this.params = params
            // Des filtres sont appliqués on rappele le serveur
            this.$store.dispatch('repartitioncandidats/getListeCentres', params).then(() => {
                const datas = _.orderBy(this.$store.state.repartitioncandidats.liste_centres, 'ville.name', 'asc')
                this.setDataForGenericTab(datas)
            })
        }
    }

    // Appelle une page lors du scroll
    loadHandler (params: any) {
        if (JSON.stringify(this.params) !== JSON.stringify(params)) {
            this.params = params
            this.$store.dispatch('repartitioncandidats/getMoreListeCentres', params).then(() => {
                const datas = _.orderBy(this.$store.state.repartitioncandidats.liste_centres, 'ville.name', 'asc')
                this.setDataForGenericTab(datas)
            })
        }
    }

    // Création des filtres pour le tableau
    setFiltersForGenericTab()
    {
        // Options filières
        const filieres = this.$store.getters['concour/banques']
        const options_filieres = []
        for (const f in filieres) {
            options_filieres.push({ index: filieres[f].id, name: filieres[f].name })
        }

        // Options zones
        const zones = this.$store.state.ville.zones
        const options_zones = []
        for (const z in zones) {
            options_zones.push({ index: zones[z].id, name: zones[z].name })
        }

        // Options statuts
        const options_statuts = []
        options_statuts.push({ index: 0, name: 'En préparation' })
        options_statuts.push({ index: 1, name: 'En production' })
        options_statuts.push({ index: 2, name: 'En livraison' })
        options_statuts.push({ index: 3, name: 'AR Tranporteur' })
        options_statuts.push({ index: 4, name: 'AR Centre' })
        options_statuts.push({ index: -4, name: 'Validé' })

        this.filtres =
        [
            { libelle: 'Centre', defautOptionlibelle: 'Rechercher un',   model: 'name',  value: '', index: 'name', datas: null, loading: this.$store.state.repartitioncandidats.loading_repartition, options: { type: 'form', fieldsKey: 'name' } },
            { libelle: 'Ville', defautOptionlibelle: 'Rechercher une',   model: 'ville.name',  value: '', index: 'ville.name', datas: null, loading: this.$store.state.repartitioncandidats.loading_repartition, options: { type: 'form', fieldsKey: 'ville.name' } },
            { libelle: 'Filière', defautOptionlibelle: 'Rechercher une',  model: 'concours_id', value: '', index: 'filiere', datas: options_filieres, loading: this.$store.state.repartitioncandidats.loading_repartition, options: { type: 'deroulant', fieldsKey: 'filiere' } },
            { libelle: 'Zone', defautOptionlibelle: 'Rechercher une',  model: 'ville.zone_id', value: '', index: 'zone', datas: options_zones, loading: this.$store.state.repartitioncandidats.loading_repartition, options: { type: 'deroulant', fieldsKey: 'zone' } },
            { libelle: 'Statut', defautOptionlibelle: 'Rechercher un',  model: 'f_suj_statut', value: '', index: 'sujets', datas: options_statuts, loading: this.$store.state.repartitioncandidats.loading_repartition, options: { type: 'deroulant', fieldsKey: 'sujets' } },
            { libelle: 'Statut', defautOptionlibelle: 'Rechercher un',  model: 'f_pap_statut', value: '', index: 'fournitures_papetieres', datas: options_statuts, loading: this.$store.state.repartitioncandidats.loading_repartition, options: { type: 'deroulant', fieldsKey: 'fournitures_papetieres' } },
            { libelle: 'Statut', defautOptionlibelle: 'Rechercher un',  model: 'f_adm_statut', value: '', index: 'fournitures_administratives', datas: options_statuts, loading: this.$store.state.repartitioncandidats.loading_repartition, options: { type: 'deroulant', fieldsKey: 'fournitures_administratives' } }
        ]
    }

    // Ouvre le popup de paramétrage de la visualisation de l'inventaire
    open_publication_inventaire () {
        this.showPopupPublicationInventaire = true
    }

    // Ferme la popup de paramétrage de la visualisation de l'inventaire
    close_publication_inventaire () {
        this.showPopupPublicationInventaire = false
    }

    // Check la cohérence des dates avant envoi au serveur
    checkInputValidation () {
        this.$store.state.session.error = null
        this.betweenError = ''
        this.onlyEndDateError = ''
        let valid = false
        const dateNow = new Date(Date.now()).toISOString()

        switch (this.selectedDate.userSelectDateType) {
            case 'between':
                if (diffTwoDatesInMinutes(this.selectedDate.dateBetween.date_start, this.selectedDate.dateBetween.date_end) < 0) {
                    this.betweenError = 'La date d\'ouverture doit être antérieure ou égale à la date de fermeture.'
                } else if (this.selectedDate.dateBetween.date_start === '' || this.selectedDate.dateBetween.date_end === '') {
                    this.betweenError = 'La date d\'ouverture et la date de fermeture doivent être saisies.'
                } else if (diffTwoDatesInMinutes(formatDateYYYYMMDD(dateNow), this.selectedDate.dateBetween.date_start) < 0) {
                    this.betweenError = 'La date d\'ouverture doit être postérieure ou égale à la date d\'aujourd\'hui.'
                }  else if (diffTwoDatesInMinutes(formatDateYYYYMMDD(dateNow), this.selectedDate.dateBetween.date_end) < 0) {
                    this.betweenError = 'La date de fermeture doit être postérieure ou égale à la date d\'aujourd\'hui.'
                } else {
                    this.betweenError = ''
                    valid = true
                }
                break
            case 'onlyEndDate':
                if (diffTwoDatesInMinutes(formatDateYYYYMMDD(dateNow), this.selectedDate.onlyEndDate.date_end) < 0) {
                    this.onlyEndDateError = 'La date de saisie doit être postérieure ou égale à la date d\'aujourd\'hui.'
                } else if (this.selectedDate.onlyEndDate.date_end === '') {
                    this.onlyEndDateError = 'La date doit être saisie.'
                } else {
                    this.onlyEndDateError = ''
                    valid = true
                }
                break
            case 'closeInput':
                valid = true
                break
            default:
                break
        }

        if (valid) {
            this.save_publication_inventaire()
        }
    }

    /** formatte une valeur string de type'YYYY-MM-DD HH:mm:ss' en valeur moment YYYY-MM-DDTHH:mm:ss[Z] */
    convertDateToIso = (dateString: string | undefined) => {
        if (dateString) {
            return formatDayHourZDateFromString(dateString)
        }
    }

    // Sauvegarde de la publication de l'inventaire
    save_publication_inventaire () {
        let params = {}
        const id = this.$store.getters['session/sessionSelect'].id

        switch (this.selectedDate.userSelectDateType) {
            case 'between':
                params = {
                    inventaire_fournitures_start_at:  this.convertDateToIso(this.selectedDate.dateBetween.date_start),
                    inventaire_fournitures_end_at:    this.convertDateToIso(formatEndOfDayHourZDateFromString(this.selectedDate.dateBetween.date_end)) // La journée de fermeture est incluse
                }
                break
            case 'onlyEndDate':
                params = {
                    inventaire_fournitures_start_at:  null,
                    inventaire_fournitures_end_at:    this.convertDateToIso(formatEndOfDayHourZDateFromString(this.selectedDate.onlyEndDate.date_end)) // La journée de fermeture est incluse
                }
                break
            case 'closeInput':
                params = {
                    inventaire_fournitures_start_at:  null,
                    inventaire_fournitures_end_at:    null
                }
                break
            default:
                break
        }
        const idInfo = 't_info_' + Math.random()
        const infosToaster = {
            id: idInfo,
            toaster: 'b-toaster-top-right',
            variant: 'primary',
            noCloseButton: true,
            fade: true,
            noAutoHide: true
        }
        this.$bvToast.toast('Enregistrement en cours ...', infosToaster)

        this.$store.dispatch('session/updateSessionInventaireFourniture', { session_id: id, payload: params }).then((response) => {
            this.$bvToast.hide(idInfo)
            const idSucces = 't_succes_' + Math.random()
            const succesToaster = {
                id: idSucces,
                toaster: 'b-toaster-top-right',
                variant: 'success',
                noCloseButton: true,
                fade: true,
                autoHideDelay: 5000
            }
            this.$store.state.session.sessionSelect = response.data.data
            this.$bvToast.toast('Enregistrement terminé.', succesToaster)
            this.close_publication_inventaire()
        }).catch((error) => {
            this.$bvToast.hide(idInfo)
            console.log('ko:' + error)
        })
    }

    // Ouvre le popup de relance des centres
    open_relance_centre () {
        this.showPopupRelanceCentre = true
    }

    // Ferme le popup de relance des centres
    close_relance_centre () {
        this.showPopupRelanceCentre = false
    }

    // Enregistre la relance des centres
    save_relance_centre () {
        const idInfo = 't_info_' + Math.random()
        const infosToaster = {
            id: idInfo,
            toaster: 'b-toaster-top-right',
            variant: 'primary',
            noCloseButton: true,
            fade: true,
            noAutoHide: true
        }
        this.$bvToast.toast('Envoi en cours...', infosToaster)

        this.$store.dispatch('fourniture/relaunchSuiviFournitures').then(() => {
            this.$bvToast.hide(idInfo)
            const idSucces = 't_succes_' + Math.random()
            const succesToaster = {
                id: idSucces,
                toaster: 'b-toaster-top-right',
                variant: 'success',
                noCloseButton: true,
                fade: true,
                autoHideDelay: 5000
            }
            this.$bvToast.toast('Envoi terminé.', succesToaster)
            this.showPopupRelanceCentre = false
        }).catch(() => {
            this.$bvToast.hide(idInfo)
        })
    }

    // Initialise les dates pour la publication de l'inventaire
    initDates() {
        const activeSession = this.$store.getters['session/sessionSelect']

        if (activeSession && activeSession.inventaire_fournitures_end_at !== null && activeSession.inventaire_fournitures_start_at !== null) {
            this.selectedDate.dateBetween.date_start = formatDateYYYYMMDD(activeSession.inventaire_fournitures_start_at)
            this.selectedDate.dateBetween.date_end = formatDateYYYYMMDD(activeSession.inventaire_fournitures_end_at)
            this.selectedDate.onlyEndDate.date_end = ''
            this.selectedDate.userSelectDateType = 'between'
        } else if (activeSession && activeSession.inventaire_fournitures_end_at !== null) {
            this.selectedDate.onlyEndDate.date_end = formatDateYYYYMMDD(activeSession.inventaire_fournitures_end_at)
            this.selectedDate.dateBetween.date_start = ''
            this.selectedDate.dateBetween.date_end = ''
            this.selectedDate.userSelectDateType = 'onlyEndDate'
        }
    }

    // Ouvre le popup de sélection de zones pour l'export de la commande des sujets
    open_select_zone() {
        this.showPopupOptionsZones = true
    }

    // Ferme la popup de selection de zones
    close_selection_zone () {
        this.options_zones_export = []
        this.showPopupOptionsZones = false
    }

    // Export des fichiers de commandes
    exporter (type_fichier: string) {
        this.exportingIsWorking = true
        let params = {}
        let fileName = 'commande_' + type_fichier + '.xlsx'
        let dispatch_link = ''

        switch (type_fichier) {
            case 'sujets':
                params = this.options_zones_export
                dispatch_link = 'centre/exportCommandeSujets'
                break
            case 'fournitures_papetieres':
                dispatch_link = 'centre/exportCommandeFournituresPap'
                break
        }

        const idInfo = 't_info_' + Math.random()
        const infosToaster = {
            id: idInfo,
            toaster: 'b-toaster-top-right',
            variant: 'primary',
            noCloseButton: true,
            fade: true,
            noAutoHide: true
        }
        this.$bvToast.toast('Export en cours de création ...', infosToaster)

        this.$store.dispatch(dispatch_link, params).then((response) => {
            const fileNameTemp = getFileNameFromHeader(response.headers)
            if (fileNameTemp) {
                fileName = fileNameTemp
            }
            const url = URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute(
                'Download',
                fileName
            )
            document.body.appendChild(link)
            link.click()
            this.exportingIsWorking = false
            this.showPopupOptionsZones = false
            this.$bvToast.hide(idInfo)
        }).catch((error) => {
            this.exportingIsWorking = false
            this.$bvToast.hide(idInfo)
            console.log('ko: ', error)
        })
    }

    // ----- gestion du nombre de sujets --------------------

    /**
     * on bloque la saisie de '.' et de ',' dans les inputs de type number déstiné à recevoir des entiers
     */
    checkKeyUp (e: any) {
        if (e.target.value.includes(',')) {
            e.target.value = e.target.value.replace(',', '')
        }
        if (e.target.value.includes('.')) {
            e.target.value = e.target.value.replace('.', '')
        }
    }

    /**
     * ouvre la fenetre de paramétrage du nombre prévisionnel de sujets
     */
    openGestionNombreSujets () {
        this.listeSujets = []
        const filieres = this.$store.getters['concour/banques']
        this.options_filieres = []
        for (const f in filieres) {
            this.options_filieres.push({ index: filieres[f].id, name: filieres[f].name })
        }
        this.$store.dispatch('sujet/getPrevisionnelSujets').then((response) => {
            this.marge_securite = this.$store.getters['session/sessionSelect'].sujet_marge_securite
            this.sujet_supplementaire = this.$store.getters['session/sessionSelect'].sujet_supplementaires
            this.openGestionNombreSujetsSuite(response)
        }).catch((error) => {
            console.log('ko:' + error)
        })
    }

    openGestionNombreSujetsSuite (response: any) {
        for (let i = 0; i < response.data.data.length; i++) {
            this.listeSujets.push({
                id: response.data.data[i].id,
                code:  response.data.data[i].sujet ? response.data.data[i].sujet.reference : '',
                name:  response.data.data[i].sujet ? response.data.data[i].sujet.name : '',
                concour_id: response.data.data[i].concour_id,
                concour_code: response.data.data[i].concour.code,
                estimation_nb_candidats: response.data.data[i].nb_candidats,
                nb_sujets: response.data.data[i].nb_commande,
                nb_sujets_attendu: response.data.data[i].nb_commande,
                nb_pages:  response.data.data[i].sujet ? Number(response.data.data[i].sujet.nb_pages) : 0,
                pages_imprimees: response.data.data[i].sujet ? Number(response.data.data[i].nb_sujets) * Number(response.data.data[i].sujet.nb_pages) : 0
            })
            this.listeSujetsOriginal = this.listeSujets
        }
        this.showGestionNombreSujets = true
        this.getTotalSujetsAttendu()
        this.getTotalPagesImprimees()
    }

    /**
     * ferme la fenetre de paramétrage du nombre prévisionnel de sujets
     */
    cancelGestionNombreSujets () {
        this.showGestionNombreSujets = false
    }

    /**
     * filtre les épreuves par filière
     */
    filiereSujetChangeHandler () {
        this.listeSujets = []
        if (this.filiere_gestion_nombre_sujets !== 'null') {
            for (let i = 0; i < this.listeSujetsOriginal.length; i++) {
                if (this.listeSujetsOriginal[i].concour_id === this.filiere_gestion_nombre_sujets) {
                    this.listeSujets.push(this.listeSujetsOriginal[i])
                }
            }
        } else {
            for (let i = 0; i < this.listeSujetsOriginal.length; i++) {
                this.listeSujets.push(this.listeSujetsOriginal[i])
            }
        }
        this.getTotalSujetsAttendu()
    }

    /**
     * calcul du nombre de sujets attendus par épreuve en prenant en compte la marge de sécurité et l'ajout de sujet supplémentaire
     * info affiché dans le title du point d'exclamation rouge qui s'affiche lorsque le nombre de sujets renseignés dans l'input est différent du nombre de sujets attendus
     */
    getTotalSujetsAttendu () {
        for (let i = 0; i < this.listeSujets.length; i++) {
            this.listeSujets[i].nb_sujets_attendu = this.listeSujets[i].estimation_nb_candidats
            if (this.marge_securite > 0) {
                this.listeSujets[i].nb_sujets_attendu = Number(this.listeSujets[i].nb_sujets_attendu) + Math.ceil((Number(this.listeSujets[i].nb_sujets_attendu) * Number(this.marge_securite) / 100))
            }
            this.listeSujets[i].nb_sujets_attendu = Number(this.listeSujets[i].nb_sujets_attendu) + Number(this.sujet_supplementaire)
        }
        this.getTotalPagesImprimees()
    }

    /**
     * calcul le nombre total de pages imprimées
     */
    getTotalPagesImprimees () {
        this.totalPagesImprimees = 0
        for (let i = 0; i < this.listeSujets.length; i++) {
            this.listeSujets[i].pages_imprimees = Math.ceil(Number(this.listeSujets[i].nb_sujets) * Number(this.listeSujets[i].nb_pages))
            this.totalPagesImprimees = Number(this.totalPagesImprimees) + Number(this.listeSujets[i].pages_imprimees)
        }
    }

    /**
     * calcul du nombre de pages imprimées lors de la modification du nombre de sujets d'une épreuve
     */
    nbSujetChangeHandler (sujet: any) {
        sujet.pages_imprimees = Number(sujet.nb_sujets) * Number(sujet.nb_pages)
        this.getTotalPagesImprimees()
    }

    /**
     *  recalcul du nombre de sujets et du nombre de pages impriméés
     */
    updateMargePrevisionnelSujets () {
        for (let i = 0; i < this.listeSujets.length; i++) {
            this.listeSujets[i].nb_sujets = this.listeSujets[i].estimation_nb_candidats
            if (this.marge_securite > 0) {
                this.listeSujets[i].nb_sujets = Number(this.listeSujets[i].nb_sujets) + Math.ceil((Number(this.listeSujets[i].nb_sujets) * Number(this.marge_securite) / 100))
            }
            this.listeSujets[i].nb_sujets_attendu = this.listeSujets[i].nb_sujets = Number(this.listeSujets[i].nb_sujets) + Number(this.sujet_supplementaire)
            this.listeSujets[i].pages_imprimees = Math.ceil(Number(this.listeSujets[i].nb_sujets) * Number(this.listeSujets[i].nb_pages))
        }
        this.getTotalPagesImprimees()
    }

    /**
     * enregistrement dans la session de la valeur de la marge de sécurité et du nombre de sujets supplémentaires puis enregistrement du nombre de sujets et l'estimation des nombres de candidats des épreuves
     */
    updatePrevisionnelSujets () {
        const data = {
            sujet_marge_securite: this.marge_securite,
            sujet_supplementaires: this.sujet_supplementaire
        }
        const idInfo = 't_info_' + Math.random()
        const infosToaster = {
            id: idInfo,
            toaster: 'b-toaster-top-right',
            variant: 'primary',
            noCloseButton: true,
            fade: true,
            noAutoHide: true
        }

        this.$bvToast.toast('Enregistrement en cours ...', infosToaster)
        this.$store.dispatch('sujet/updateMargePrevisionnelSujets', data).then(() => {
            this.$store.getters['session/sessionSelect'].sujet_marge_securite = this.marge_securite
            this.$store.getters['session/sessionSelect'].sujet_supplementaires = this.sujet_supplementaire
            const concour_sujets_temps: Array<{id: number; nb_commande: number}> = []
            for (let i = 0; i < this.listeSujets.length; i++) {
                concour_sujets_temps.push({
                    id: this.listeSujets[i].id,
                    nb_commande: this.listeSujets[i].nb_sujets
                })
            }

            const datab: { concour_sujets: Array<{id: number; nb_commande: number}> } = {
                concour_sujets: concour_sujets_temps
            }
            this.$store.dispatch('sujet/updatePrevisionnelSujets', datab).then(() => {
                this.$bvToast.hide(idInfo)
                const idSucces = 't_succes_' + Math.random()
                const succesToaster = {
                    id: idSucces,
                    toaster: 'b-toaster-top-right',
                    variant: 'success',
                    noCloseButton: true,
                    fade: true,
                    autoHideDelay: 5000
                }
                this.$bvToast.toast('Enregistré avec succès !', succesToaster)
            // this.openGestionNombreSujets()
            }).catch((error) => {
                this.$bvToast.hide(idInfo)
                console.log('ko:' + error)
            })
        }).catch((error) => {
            this.$bvToast.hide(idInfo)
            console.log('ko:' + error)
        })
    }

    /**
     * demande au serveur d'un export excel du nombre de sujets, l'estimation des nombres de candidats et du nombre de pages imprimées
     */
    exportPrevisionnelSujets () {
        this.exportingIsWorking = true
        let fileName = 'export_previsionnel_sujets.xlsx'

        const idInfo = 't_info_' + Math.random()
        const infosToaster = {
            id: idInfo,
            toaster: 'b-toaster-top-right',
            variant: 'primary',
            noCloseButton: true,
            fade: true,
            noAutoHide: true
        }
        this.$bvToast.toast('Export en cours de création ...', infosToaster)

        this.$store.dispatch('sujet/exportPrevisionnelSujets').then((response) => {
            const fileNameTemp = getFileNameFromHeader(response.headers)
            if (fileNameTemp) {
                fileName = fileNameTemp
            }
            const url = URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute(
                'Download',
                fileName
            )
            document.body.appendChild(link)
            link.click()
            this.exportingIsWorking = false
            this.$bvToast.hide(idInfo)
        }).catch((error) => {
            this.exportingIsWorking = false
            this.$bvToast.hide(idInfo)
            console.log('ko: ', error)
        })
    }

    // Ouvre la popup de paramétrage de la marge de commande
    openMargeCommande () {
        if (this.$store.state.session.sessionSelect) {
            this.params_marge.sujet_commande_marge_securite = this.$store.state.session.sessionSelect.sujet_commande_marge_securite
            this.params_marge.sujet_commande_supplementaires_min = this.$store.state.session.sessionSelect.sujet_commande_supplementaires_min
            this.params_marge.sujet_commande_supplementaires_max = this.$store.state.session.sessionSelect.sujet_commande_supplementaires_max
        }

        this.showPopupMargeCommande = true
    }

    // Ferme la popup de gestion de la marge de commande
    close_marge_commande () {
        this.showPopupMargeCommande = false
    }

    // Save la marge de commande
    save_marge_commande () {
        this.save_in_progress = true

        this.$store.dispatch('sujet/saveMargeCommande', this.params_marge).then((response) => {
            this.$store.state.session.sessionSelect = response.data.data
            const idSucces = 't_succes_' + Math.random()
            const succesToaster = {
                id: idSucces,
                toaster: 'b-toaster-top-right',
                variant: 'success',
                noCloseButton: true,
                fade: true,
                autoHideDelay: 5000
            }
            this.$bvToast.toast('Enregistrement terminé.', succesToaster)
            this.showPopupMargeCommande = false
            this.save_in_progress = false
        }).catch(() => {
            this.save_in_progress = false
        })
    }

    // Ouvre le popup de changement de statut pour tous les centres
    open_statut_centre (statut: string) {
        this.type_statut = statut
        this.showPopupStatutCentre = true
    }

    // Ferme la popup de changement de statut pour tous les centres
    close_statut_centre () {
        this.type_statut = ''
        this.statut_centre = null
        this.info_statut_centre = ''
        this.showPopupStatutCentre = false
    }

    // Save le changement de statut pour tous les centres
    save_statut_centre () {
        if (this.statut_centre !== null) {
            this.save_in_progress = true
            let params: any = {}

            switch (this.type_statut) {
                case 'Sujets':
                    params = {
                        f_suj_statut: this.statut_centre
                    }
                    break
                case 'Fournitures papetières':
                    params = {
                        f_pap_statut: this.statut_centre
                    }
                    break
                case 'Fournitures administratives':
                    params = {
                        f_adm_statut: this.statut_centre
                    }
                    break
            }

            this.$store.dispatch('centre/updateCentreFournituresStatut', params).then((response) => {
                this.$store.state.session.sessionSelect = response.data.data
                const idSucces = 't_succes_' + Math.random()
                const succesToaster = {
                    id: idSucces,
                    toaster: 'b-toaster-top-right',
                    variant: 'success',
                    noCloseButton: true,
                    fade: true,
                    autoHideDelay: 5000
                }
                this.$bvToast.toast('Enregistrement terminé.', succesToaster)
                this.$store.dispatch('repartitioncandidats/getListeCentres').then(() => {
                    this.save_in_progress = false
                    this.setFiltersForGenericTab()
                    this.close_statut_centre()
                })
            }).catch(() => {
                this.save_in_progress = false
            })
        }
    }

    // ------- Bibliothèque de documents -------
    showBibliothequeDocuments = false

    modeEditDocument = false

    showModalMessageDeleteDocument = false

    exportWorking = false

    documents: Array<FournitureAdministrativeInterface> = []

    activeSession: any = null

    /**
     * id
        session_id
        code
        name
        ordre
        actif
        dispo_numerique
        dispo_papier
        custom
        bac_impression
     */

    documentTemp: FournitureAdministrativeInterface | null = null
    // --- documents

    /**
     * ouvre la fenetre de gestion/ bibliothèque des documents de l'ensemble de centres
     */
    openBibliothequeDocuments () {
        this.$store.dispatch('fournitureAdministrative/getFournitureAdministratives', { 'filter-custom': 1 }).then((response) => {
            this.documents = response.data.data
            this.showBibliothequeDocuments = true
            this.etatConsultation.ouverture = this.activeSession.bibliotheque_fa_start_at ? new Date(this.activeSession.bibliotheque_fa_start_at).toISOString().split('T')[0] : null
            this.etatConsultation.fermeture = this.activeSession.bibliotheque_fa_end_at ? new Date(this.activeSession.bibliotheque_fa_end_at).toISOString().split('T')[0] : null
            if (this.etatConsultation.ouverture && this.etatConsultation.fermeture) {
                this.etatConsultation.etat = 1
            } else if (this.etatConsultation.fermeture) {
                this.etatConsultation.etat = 2
            } else {
                this.etatConsultation.etat = 0
            }
            this.etatConsultationChangeHandler()
        })
    }

    /**
     * ferme la fenetre de gestion/ bibliothèque des documents de l'ensemble de centres
     */
    cancelBibliothequeDocuments () {
        this.showBibliothequeDocuments = false
    }

    /**
     * affiche le formulaire d'ajout de document
     */
    addDocument () {
        this.documentTemp = {
            id: 0,
            session_id: this.$store.getters['auth/user_session_id'],
            code: '',
            name: '',
            ordre: 1,
            actif: 1,
            dispo_numerique: 0,
            dispo_papier: 0,
            custom: 1,
            bac_impression: 0,
            document: null
        }
        this.modeEditDocument = true
        this.modeSoftDeleteDoc = false
    }

    /**
     * affiche le formulaire d'edition de document
     */
    editDocument (document: any) {
        console.log('editBibliothequeDocuments')
        this.documentTemp = JSON.parse(JSON.stringify(document))
        this.modeEditDocument = true
        this.documentFileTemp = null
        this.modeSoftDeleteDoc = false
    }

    /**
     * enregistre le document ajouté/edité
     */
    saveEditDocument() {
        if (this.documentTemp) {
            this.$store.commit('fournitureAdministrative/SET_ERROR', null)
            const formdata = new FormData()

            formdata.set('id', this.documentTemp.id.toString())
            formdata.set('session_id', this.documentTemp.session_id.toString())
            formdata.set('code', this.documentTemp.code.toString())
            formdata.set('name', this.documentTemp.name.toString())
            formdata.set('ordre', this.documentTemp.ordre.toString())
            formdata.set('actif', this.documentTemp.actif.toString())
            formdata.set('dispo_numerique', this.documentTemp.dispo_numerique ? '1' : '0')
            formdata.set('dispo_papier', this.documentTemp.dispo_papier ? '1' : '0')
            formdata.set('custom', this.documentTemp.custom.toString())
            formdata.set('bac_impression', this.documentTemp.bac_impression.toString())
            if (this.documentFileTemp) {
                formdata.set('document', this.documentFileTemp)
            }

            const idInfo = 't_info_' + Math.random()
            const infosToaster = {
                id: idInfo,
                toaster: 'b-toaster-top-right',
                variant: 'primary',
                noCloseButton: true,
                fade: true,
                noAutoHide: true
            }
            this.$bvToast.toast('Enregistrement en cours ...', infosToaster)
            if (this.documentTemp.id === 0) {
                formdata.set('_method', 'POST')
                // Création d'une fourniture administrative
                this.$store.dispatch('fournitureAdministrative/addFournitureAdministrative', formdata).then(() => {
                    this.$bvToast.hide(idInfo)

                    const idSucces = 't_succes_' + Math.random()
                    const succesToaster = {
                        id: idSucces,
                        toaster: 'b-toaster-top-right',
                        variant: 'success',
                        noCloseButton: true,
                        fade: true,
                        autoHideDelay: 5000
                    }
                    this.$bvToast.toast('Enregistrement terminé !', succesToaster)


                    this.$store.dispatch('fournitureAdministrative/getFournitureAdministratives', { 'filter-custom': 1 }).then((response) => {
                        this.annulerEditDocument()
                        this.documentTemp = null
                        this.documents = response.data.data
                    })
                }).catch(() => {
                    this.$bvToast.hide(idInfo)
                })
            } else {
                // Modification d'un fourniture administrative
                formdata.set('_method', 'PUT')
                this.$store.dispatch('fournitureAdministrative/updateFournitureAdministrative', { fa_id:this.documentTemp.id, payload: formdata }).then(() => {
                    this.$bvToast.hide(idInfo)
                    const idSucces = 't_succes_' + Math.random()
                    const succesToaster = {
                        id: idSucces,
                        toaster: 'b-toaster-top-right',
                        variant: 'success',
                        noCloseButton: true,
                        fade: true,
                        autoHideDelay: 5000
                    }
                    this.$bvToast.toast('Enregistrement terminé !', succesToaster)
                    this.$store.dispatch('fournitureAdministrative/getFournitureAdministratives', { 'filter-custom': 1 }).then((response) => {
                        this.annulerEditDocument()
                        this.documentTemp = null
                        this.documents = response.data.data
                    })
                }).catch(() => {
                    this.$bvToast.hide(idInfo)
                })
            }
        }
    }

    /**
     * masque le fichier le document en cours d'édition afin de le remplacer
     */
    modeSoftDeleteDoc = false
    softDeleteDocument() {
        this.modeSoftDeleteDoc = true
    }

    /**
     * memorise le fichier selectionné pour le document en cours de création/édition
     */
    documentFileTemp: any = null
    selectFile (e: Event) {
        if (e.target !== null && this.documentTemp) {
            const target = e.target as HTMLInputElement
            const file: File = (target.files as FileList)[0]
            this.documentFileTemp = file
        }
    }

    /**
     * ferrme le formulaire d'edition d'un document
     */
    annulerEditDocument () {
        this.modeEditDocument = false
        this.documentTemp = null
    }

    /**
     * lance le telechargement d'un document
     */
    dlDocumentPdf (doc: any) {
        // this.$store.commit('candidat/SET_ERROR', null)
        let fileName = ''
        this.exportWorking = true

        const idInfo = 't_info_' + Math.random()
        const infosToaster = {
            id: idInfo,
            toaster: 'b-toaster-top-right',
            variant: 'primary',
            noCloseButton: true,
            fade: true,
            noAutoHide: true
        }
        this.$bvToast.toast('Export en cours...', infosToaster)

        this.$store.dispatch('fournitureAdministrative/getPDFFournitureAdministrative', { fa_id: doc.id, doc_id: doc.document[0].id }).then(response => {
            const fileNameTemp = doc.document[0].name // getFileNameFromHeader(response.headers) || 'document.pdf'
            if (fileNameTemp) {
                fileName = fileNameTemp
            }
            const url = URL.createObjectURL(new Blob([base64ToArrayBuffer(response.data)]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute(
                'Download',
                fileName
            )
            document.body.appendChild(link)
            link.click()
            this.$bvToast.hide(idInfo)
            this.exportWorking = false
        }).catch(() => {
            this.$bvToast.hide(idInfo)
            this.exportWorking = false
        })
    }

    /**
     * ouvre la fenetre de confirmation de suppression d'un document
     */
    deleteDocument (document: any) {
        this.$store.state.document.error = null
        this.documentTemp = JSON.parse(JSON.stringify(document))
        this.showModalMessageDeleteDocument = true
    }

    getDocumentError() {
        return this.$store.state.fournitureAdministrative.error
    }

    /**
     * ferme la fenêtre et annule la demande de confirmation de suppression d'un sujet
     */
    cancelDeleteDocument () {
        this.documentTemp = null
        this.showModalMessageDeleteDocument = false
    }

    /**
     * confirme et envoi au serveur une demande de suppresion de sujet
     */
    deleteSuiteDocument () {
        const idInfo = 't_info_' + Math.random()
        const infosToaster = {
            id: idInfo,
            toaster: 'b-toaster-top-right',
            variant: 'primary',
            noCloseButton: true,
            fade: true,
            noAutoHide: true
        }

        this.$bvToast.toast('Suppression en cours ...', infosToaster)
        this.$store.dispatch('fournitureAdministrative/deleteFournitureAdministrative',  this.documentTemp?.id).then(() => {
            for (let i = 0;  i < this.documents.length; i++) {
                if (this.documentTemp?.id === this.documents[i].id) {
                    this.documents.splice(i, 1)
                }
            }
            this.$bvToast.hide(idInfo)
            const idSucces = 't_succes_' + Math.random()
            const succesToaster = {
                id: idSucces,
                toaster: 'b-toaster-top-right',
                variant: 'success',
                noCloseButton: true,
                fade: true,
                autoHideDelay: 5000
            }
            this.$bvToast.toast('Suppression terminée.', succesToaster)
            this.documentTemp = null
            this.showModalMessageDeleteDocument = false
        }).catch((error) => {
            this.$bvToast.hide(idInfo)
            console.log('ko:' + error)
        })
    }


    // --- etatConsultation

    etatConsultation: {etat: number; ouverture: string|null; fermeture: string|null} = {
        etat: 1,
        ouverture: null, // new Date(Date.now()).toISOString().split('T')[0],
        fermeture: null //  new Date(Date.now()).toISOString().split('T')[0]
    }

    /**
     * gère les changements d'état du formulaire de la consultation des documents
     */
    dateErreur = ''
    etatConsultationChangeHandler () {
        this.dateErreur = ''
        const dateNow = new Date(Date.now()).toISOString()

        if (Number(this.etatConsultation.etat) === 1) {
            if (!this.etatConsultation.ouverture || !this.etatConsultation.fermeture) {
                this.dateErreur = 'La date d\'ouverture et la date de fermeture doivent être saisies...'
            } else if (this.etatConsultation.ouverture === '' || this.etatConsultation.fermeture === '') {
                this.dateErreur = 'La date d\'ouverture et la date de fermeture doivent être saisies...'
            } else {
                const ouvert = new Date(this.etatConsultation.ouverture).toISOString()
                const ferme = new Date(this.etatConsultation.fermeture).toISOString()
                if (diffTwoDatesInMinutes(ouvert, ferme) < 0) {
                    this.dateErreur = 'La date d\'ouverture doit être antérieure ou égale à la date de Fermeture...'
                } else if (diffTwoDatesInMinutes(formatDateYYYYMMDD(dateNow), ouvert) < 0) {
                    this.dateErreur = 'La date d\'ouverture doit être postérieure ou égale à la date d\'aujourd\'hui...'
                }  else if (diffTwoDatesInMinutes(formatDateYYYYMMDD(dateNow), ferme) < 0) {
                    this.dateErreur = 'La date de fermeture doit être postérieure ou égale à la date d\'aujourd\'hui...'
                }
            }
        } else if (Number(this.etatConsultation.etat) === 2) {
            if (!this.etatConsultation.fermeture) {
                this.dateErreur = 'La date de fermeture doit être saisie...'
            } else if (this.etatConsultation.fermeture === '') {
                this.dateErreur = 'La date de fermeture doit être saisie...'
            }  else  {
                const ferme = new Date(this.etatConsultation.fermeture).toISOString()
                if (diffTwoDatesInMinutes(formatDateYYYYMMDD(dateNow), ferme) < 0) {
                    this.dateErreur = 'La date de fermeture doit être postérieure ou égale à la date d\'aujourd\'hui...'
                }
            }
        }
    }

    /**
     * enregistre les changements d'état de la consultation des documents
     */
    updateEtatConsultation () {
        console.log(this.etatConsultation)
        let date_end: any = null
        if (this.etatConsultation.fermeture) {
            date_end =  moment(this.etatConsultation.fermeture).local()
            date_end.hours(23)
            date_end.minutes(59)
            date_end.seconds(59)
        }
        const datasConsultation  = {
            bibliotheque_fa_start_at : this.etatConsultation.ouverture,
            bibliotheque_fa_end_at : date_end.toISOString()
        }
        if (Number(this.etatConsultation.etat) === 0) {
            datasConsultation.bibliotheque_fa_start_at = null
            datasConsultation.bibliotheque_fa_end_at = null
        } else if (Number(this.etatConsultation.etat) === 2) {
            datasConsultation.bibliotheque_fa_start_at = null
        }

        const idInfo = 't_info_' + Math.random()
        const infosToaster = {
            id: idInfo,
            toaster: 'b-toaster-top-right',
            variant: 'primary',
            noCloseButton: true,
            fade: true,
            noAutoHide: true
        }
        this.$bvToast.toast('Enregistrement en cours ...', infosToaster)

        this.$store.dispatch('fournitureAdministrative/setConsultationFournituresAdministratives', datasConsultation).then((response) => {
            this.activeSession = response.data.data
            this.$bvToast.hide(idInfo)
            const idSucces = 't_succes_' + Math.random()
            const succesToaster = {
                id: idSucces,
                toaster: 'b-toaster-top-right',
                variant: 'success',
                noCloseButton: true,
                fade: true,
                autoHideDelay: 5000
            }
            this.$bvToast.toast('Enregistrement terminé !', succesToaster)
        }).catch(() => {
            this.$bvToast.hide(idInfo)
        })
    }


    // -----------------------

    // Function de chargement des éléments
    load () {
        // Chargement des concours

        this.activeSession = this.$store.getters['session/sessionSelect']
        this.$store.dispatch('concour/getConcours')

        // Chargement des zones
        this.$store.dispatch('ville/getZones').then(() => {
            for (const z in this.$store.state.ville.zones) {
                this.options_zones_export.push(this.$store.state.ville.zones[z].id)
            }
        })

        // Chargement des compteurs issus du dashboard
        this.$store.dispatch('dashboardEcrits/getDashboardInformations').then((response: any) => {
            this.infos = response.data.data
        })

        this.initDates()

        // Chargement des centres
        this.$store.dispatch('repartitioncandidats/getListeCentres').then(() => {
            this.setFiltersForGenericTab()
        })
    }

    mounted () {
        if (this.$store.getters['auth/user_session_id'] !== null) {
            this.$store.state.repartitioncandidats.loading_repartition = true
            this.load()
        }
    }
}
